import Flickity from 'flickity';
import { videoLoaded } from '../../src/js/events';

import MobileCarousel from '../../src/js/mobile-carousel';

export default class SocialProofBoxes {
  constructor() {
    this.progress = 0;
    this.$boxes = document.querySelector('.js-social-proof-boxes');
    this.boxesCarousel = new MobileCarousel(this.$boxes);
  }
}
